import {Values} from '@wix/devzai-utils-common';
import {DoppeBusinessEntity} from './doppe-business-entity';
import {DoppeAutoProductType} from './doppe-auto-product-type';

export const DoppeBlogPostsExternalDataSourceType = {
    LatestWixBlogPosts: 'LatestWixBlogPosts',
    LatestHoppBlogPosts: 'LatestHoppBlogPosts'
} as const;

export type DoppeBlogPostsExternalDataSourceType = Values<typeof DoppeBlogPostsExternalDataSourceType>;

export type DoppeBlogPostsExternalDataSource =
    | {
    type: typeof DoppeBlogPostsExternalDataSourceType.LatestWixBlogPosts;
} | {
    type: typeof DoppeBlogPostsExternalDataSourceType.LatestHoppBlogPosts;
};

export function doppeBlogPostsExternalDataSourceResolveBusinessEntityReferences(
    externalDataSource: DoppeBlogPostsExternalDataSource
) {
    switch (externalDataSource.type) {
        case DoppeBlogPostsExternalDataSourceType.LatestWixBlogPosts: {
            return {businessEntity: DoppeBusinessEntity.WixAutoBlogPostsList, id: DoppeAutoProductType.Latest}
        }
        case DoppeBlogPostsExternalDataSourceType.LatestHoppBlogPosts: {
            return {businessEntity: DoppeBusinessEntity.HoppAutoBlogPostsList, id: DoppeAutoProductType.Latest}
        }
    }
}